// extracted by mini-css-extract-plugin
export default {"wrapper":"Loader_wrapper__2JIpf","purple":"Loader_purple__YXwYM","white":"Loader_white__WjZ6c","loading":"Loader_loading__QAXcl"};